import { createApp } from 'vue';

import { createPinia } from 'pinia';

import antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import Calendar from 'ant-design-vue/es/calendar/moment';
import DatePicker from 'ant-design-vue/es/date-picker/moment';
import TimePicker from 'ant-design-vue/es/time-picker/moment';

import CKEditor from '@ckeditor/ckeditor5-vue';
import { datadogRum } from '@datadog/browser-rum';
import * as Sentry from '@sentry/vue';
import { VueQueryPlugin } from '@tanstack/vue-query';

import Highcharts from 'highcharts';
import More from 'highcharts/highcharts-more';
import Highstock from 'highcharts/highstock';
import annotations from 'highcharts/modules/annotations';
import boost from 'highcharts/modules/boost';
import 'moment/dist/locale/ko';

import '@/assets/styles/custom-antd.scss';
import '@/assets/styles/custom-ckeditor.scss';
import '@/assets/styles/global.scss';
import '@/assets/styles/utility.scss';
import HTag from '@/components/hds/tags/HTag.vue';
import { router } from '@/router';
import sentryConfig from '@/utils/sentry';

import { DISABLED_DATADOG, MODE } from './constants/setting';
import { AutoReloader } from './utils/classes/AutoReloader';

boost(Highcharts);
annotations(Highcharts);
More(Highcharts);
Highcharts.setOptions({
  credits: { enabled: false },
});

Highstock.setOptions({
  credits: { enabled: false },
});

Sentry.init(sentryConfig);

if (!DISABLED_DATADOG) {
  datadogRum.init({
    applicationId: 'a45bcf13-6d21-4669-90d8-bceab3368687',
    clientToken: 'pub2dbde47eee5bffed408bc4b9e8249815',
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: 'haezoomv-admin-web',
    env: MODE === 'production' ? 'prod' : 'dev',
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: 'mask-user-input',
  });
}

export const boot = (app: ReturnType<typeof createApp>, isMount = true) => {
  app.component('ckeditor', CKEditor.component);
  app.component('a-date-picker-moment', DatePicker);
  app.component('a-time-picker-moment', TimePicker);
  app.component('a-calendar-moment', Calendar);

  app.component('h-tag', HTag);
  app.provide('autoReloader', new AutoReloader());

  app.use(createPinia()).use(router).use(VueQueryPlugin).use(antd);

  if (isMount) {
    app.mount('#app');
  }

  return app;
};
